import { faSignalBarsFair, faSignalBarsGood, faSignalBars, faSignalBarsWeak } from '@fortawesome/pro-duotone-svg-icons';
export const SEGMENTS_OPTIONS = [{
  id: 'beginner',
  label: 'Beginner',
  value: 'beginner',
  icon: faSignalBarsWeak
}, {
  id: 'intermediate',
  label: 'Intermediate',
  value: 'intermediate',
  icon: faSignalBarsFair
}, {
  id: 'advanced',
  label: 'Advanced',
  value: 'advanced',
  icon: faSignalBarsGood
}, {
  id: 'expert',
  label: 'Expert',
  value: 'expert',
  icon: faSignalBars
}];